const colleges = state => state.colleges;

const collegesLoading = state => state.collegesLoading;

const collegesMeta = state => state.meta;

const college = state => state.college;

const collegeLoading = state => state.collegeLoading;

const videos = state => state.videos;

const videosLoading = state => state.videosLoading;

const limitedVideos = state => state.limitedVideos;

const collegeImageUpload = state => state.collegeImageUpload;

const collegeImageUploadLoading = state => state.collegeImageUploadLoading;

const deleteCollegeImages = state => state.deleteCollegeImages;

const deleteCollegeImagesLoading = state => state.deleteCollegeImagesLoading;

const allColleges = state => state.allColleges;

const allCollegesLoading = state => state.allCollegesLoading;

export default {
  colleges,
  collegesLoading,
  collegesMeta,
  college,
  collegeLoading,
  videos,
  videosLoading,
  limitedVideos,
  collegeImageUpload,
  collegeImageUploadLoading,
  deleteCollegeImages,
  deleteCollegeImagesLoading,
  allColleges,
  allCollegesLoading
};
